export enum BrowserEnum {
  CHROME = "Chrome",
  EDGE = "Edge",
  OPERA = "Opera",
  FIREFOX = "Firefox",
  SAFARI = "Safari",
  BRAVE = "Brave",
}
